
SearchController.$inject = ['$rootScope', '$scope', '$state'];
export function SearchController($rootScope, $scope, $state) {
  $scope.$state = $state;

  // Trick due to transclusion that prevent to render correctly the child search-results
  const unsubscribeStateChangeStartFn = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState) {
    if (toState.name.startsWith('auth.alcmeon.search.tasks')) {
      $scope.loaded = false;
    }
  });
  const unsubscribeStateChangeSuccessFn = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState) {
    if (toState.name.startsWith('auth.alcmeon.search.tasks')) {
      $scope.loaded = true;
    }
  });

  $scope.$on('$destroy', unsubscribeStateChangeStartFn);
  $scope.$on('$destroy', unsubscribeStateChangeSuccessFn);

}
